import { AfterViewInit, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent, FooterComponent } from './components';
import { CookieConsentConfig } from './cookies/cookies.config';
import * as CookieConsent from 'vanilla-cookieconsent';

@Component({
  imports: [RouterModule, HeaderComponent, FooterComponent],
  selector: 'ca-root',
  template: `
    <ca-header/>
    <router-outlet/>
    <ca-footer/>
  `
})
export class AppComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'auto',
    });

    const config = { ...CookieConsentConfig };
    CookieConsent.run(config);
  }
}
